import { styled } from "linaria/react"

const Section = styled.section`
  display: block;
  margin: 3rem 0;
`

export default Section
